"use client";

import React from "react";
import { Lightbulb, BookOpen, FlaskConical, TrendingUp, Network } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  title: "Assess",
  description: "Data-driven audits to identify hidden inefficiencies and cost-saving opportunities.",
  icon: Lightbulb
}, {
  title: "Act",
  description: "Strategic negotiation and AI-powered insights to secure optimal terms.",
  icon: TrendingUp
}, {
  title: "Deliver",
  description: "Sustainable savings and continuous optimization for long-term profit growth.",
  icon: Network
}];
export default function HowWeWork() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="264091" id="how-we-work" className="py-20 bg-background overflow-hidden relative" ref={ref}>
      {}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: 'radial-gradient(circle, #0D3B66 1px, transparent 1px)',
      backgroundSize: '24px 24px'
    }}></div>
      
      <div className={`container mx-auto px-4 md:px-6 transition-all duration-1000 ease-out relative z-10 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold font-default text-primary mb-4">
            Our Process
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg !font-normal">A streamlined three-step methodology designed to maximize your procurement efficiency. We identify tangible opportunities in only 2 weeks.</p>
        </div>

        <div className="relative max-w-6xl mx-auto">
          {}
          <div className="hidden md:block absolute top-[27px] left-[15%] right-[15%] h-[2px] bg-primary/20 z-0" />
          
          {}
          <div className="md:hidden absolute left-[27px] top-[5%] bottom-[5%] w-[2px] bg-primary/20 z-0" />

          <div className="flex flex-col md:flex-row gap-10 md:gap-6 relative z-10 justify-around">
            {steps.map((step, i) => {
            const Icon = step.icon;
            return <div key={i} data-index={i} className="flex flex-row md:flex-col items-start md:items-center gap-6 flex-1 md:text-center group">
                  {}
                  <div className="relative shrink-0">
                    <div className="w-14 h-14 rounded-lg bg-white border-2 border-primary flex items-center justify-center text-primary shadow-sm transition-transform duration-300 group-hover:scale-110 group-hover:shadow-md">
                      <Icon className="w-6 h-6" />
                    </div>
                    {}
                    <div className="absolute -top-2 -right-2 w-6 h-6 rounded-md bg-accent text-accent-foreground text-xs flex items-center justify-center font-bold shadow-sm">
                      {i + 1}
                    </div>
                  </div>

                  {}
                  <div>
                    <h3 className="text-2xl font-bold font-default text-primary mb-2">
                      {step.title}
                    </h3>
                    <p className="text-muted-foreground text-sm leading-relaxed max-w-[280px] md:mx-auto">
                      {step.description}
                    </p>
                  </div>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}